// Single source for contact details and settings reused across the site.
export const SITE = {
  name: "Tehnočin DOO",
  legalName: "Tehnočin DOO Invest",
  phoneDisplay: "064 460 76 84",
  phoneHref: "tel:+381644607684",
  phoneIntl: "381644607684",
  email: "office@tehnocin.com",
  office: "Železnička 11a, Beočin",
  project: {
    name: "Beočinski trg",
    city: "Beočin",
    priceFrom: "1.200 €/m²",
  },
  social: {
    instagram: "https://www.instagram.com/tehnocin_doo/",
    facebook: "https://www.facebook.com/tehnocin",
  },
  // Enable only once the number is confirmed to be registered on Viber / WhatsApp.
  messengers: {
    viber: false,
    whatsapp: false,
  },
  officeMapQuery: "TEHNOČIN DOO invest, Železnička 11a, Beočin",
  projectMapQuery: "Beočinski trg, Beočin, Srbija",
};

export const viberHref = `viber://chat?number=%2B${SITE.phoneIntl}`;
export const whatsappHref = (text = "") =>
  `https://wa.me/${SITE.phoneIntl}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const mapEmbedSrc = (query) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`;

export const mapLink = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
